import React from 'react';
import styles from './NoteContentLine.module.less';
import classNames from 'classnames';
import { isIE } from '../../../lib/misc';
import { isNumber } from '@ekuaibao/helpers';
import { Tooltip } from 'antd';
export default function NoteContentLine(props) {
    var _a;
    var name = props.name, text = props.text, score = props.score;
    var isPositive = score >= 0;
    var isIe = isIE();
    return (React.createElement("div", { className: classNames(styles['note-content-text-wrap'], (_a = { 'dis-f': !isIe }, _a[styles['ie-note-content-text-wrap']] = isIe, _a)) },
        React.createElement(Tooltip, { title: name },
            React.createElement("div", { className: 'note-content-text-authorName-wrap' },
                React.createElement("div", { className: 'note-content-text-authorName' }, name),
                i18n.get('：'))),
        React.createElement("span", { className: classNames('note-content-text-content') }, text),
        isNumber(score) && React.createElement("span", { className: classNames(isPositive ? 'note-content-score' : 'note-content-score-minus') },
            "\u2002",
            isPositive ? "+" + score : "" + score)));
}
